import { ADD_POST, ADD_POST_ERROR, DELETE_POST, EDIT_POST, EDIT_POST_ERROR} from  '../../actions/actionTypes'

const initState = {
    eventStatus: null
 }

export default function (state= initState, action){
     
    switch(action.type){
        case ADD_POST:
            return {
                ...state,
                post: action.payload,
                eventStatus: "PostAdded"
            }
        case EDIT_POST:
            return {
                ...state,
                post: action.payload,
                eventStatus: "PostUpdated-"+ Date.now()
            } 
        case EDIT_POST_ERROR:
             return {
                ...state,
                eventStatus: "UpdateError"
            }  
        case ADD_POST_ERROR:
            return {
                ...state,
                eventStatus: "AddPostError"
            }  
    
        case DELETE_POST:
        return {
            ...state,
            eventStatus: "PostDeleted-"+ Date.now()
        }  
        default:
           return {
            ...state,
            eventStatus: null
        }       
    }

}